import React from 'react';
import { useLocation } from 'react-router-dom';
import { Instagram } from 'lucide-react';

const Footer = () => {
  const location = useLocation();

  // Don't show footer on admin pages
  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <footer className="bg-rose-900 text-white py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_studio-builder-12/artifacts/72mg2eao_%40theelenistudio.png"
              alt="Eleni Studio"
              className="w-24 h-24 mb-4 brightness-0 invert"
            />
            <p className="text-rose-100 text-sm">
              Handcrafted jewelry made with love and care
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <div className="space-y-2 text-rose-100 text-sm">
              <a
                href="https://wa.me/919513556777"
                target="_blank"
                rel="noopener noreferrer"
                className="block hover:text-white transition-colors"
              >
                WhatsApp: +91 9513556777
              </a>
              <a
                href="https://instagram.com/theelenistudio"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-white transition-colors"
              >
                <Instagram className="w-4 h-4" />
                @theelenistudio
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">About</h3>
            <p className="text-rose-100 text-sm">
              Each piece is carefully handcrafted to ensure quality and uniqueness. 
              We celebrate individuality and artisanal craftsmanship.
            </p>
          </div>
        </div>

        <div className="border-t border-rose-800 pt-8 text-center text-rose-200 text-sm">
          <p>&copy; {new Date().getFullYear()} Eleni Studio. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
